<template>
  <div :class="app_sidebar_class">
    <div class="app-sidebar-wrap rounded">
      <div class="app-sidebar-content hidden">
        <ul class="">
          <li
            class="section-item linked section-item-audio py-2 px-px px-2 sm:px-3 m-2px my-1 lg:my-0"
          >
            <a href="#" @click="mute_ambience" :class="ambience_mute_class"
              ><span>&nbsp;</span></a
            >
          </li>
          <li
            :class="
              section_linked_class(sectionCount + 1 + '') + ' section-item-home'
            "
            @click="on_section_click($event, sectionCount + 1 + '')"
          >
            <img src="../assets/icon-home.svg" />
          </li>
          <!-- section links -->
          <li
            v-for="section in appBarSections"
            :key="section.id"
            :class="section_linked_class(section.id)"
            @click="on_section_click($event, section.id)"
            v-html="section.name"
          ></li>
          <!-- responsive links (from footer) -->
          <li
            v-for="(link, index) in footer_additional_links"
            :key="'appbar_responsive_link_' + index"
            class="responsive-section-item section-item linked section-item-21 py-2 px-px px-2 sm:px-3 m-2px my-1 lg:my-0"
          >
            <a
              target="_blank"
              :href="link.href"
              @click="on_responsive_link_click($event, index)"
              >{{ link.title }}</a
            >
          </li>
        </ul>

        <a href="#" @click="mute_ambience" :class="ambience_mute_class"
          ><span>&nbsp;</span></a
        >
      </div>
    </div>
    <div class="app-sidebar-responsive" @click="toggle_responsive_menu($event)">
      <a href="#">≡</a>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "AppSidebar",
  data() {
    return {
      extra_app_sibebar_class: "",
      link_common_class: "section-item linked px-px sm:px-2 mx-px my-1 lg:my-0",
      allow_setting_active_links: true
    };
  },
  computed: {
    ...mapState([
      "app_type",
      "current_section",
      "ambience_current_vol",
      "footer_additional_links"
    ]),
    ...mapGetters(["appBarSections", "sectionCount", "eventTag"]),

    ambience_mute_class() {
      var str = "mute-ambience-link";

      if (this.ambience_current_vol == 0) {
        str += " muted";
      }
      return str;
    },
    app_sidebar_class() {
      return "hidden app_sidebar " + this.extra_app_sibebar_class;
    }
  },
  methods: {
    section_class(id) {
      var str = "section-item";
      if (id == this.current_section) {
        str += " active";
      }
      return str;
    },
    section_linked_class(id) {
      let str = " section-item-" + id;
      if (this.allow_setting_active_links && id == this.current_section) {
        str += " active";
      }
      str += " " + this.link_common_class;
      return str;
    },
    on_section_click(e, id) {
      this.allow_setting_active_links = true;
      // this.$bus.$emit("send_interactive_msg", "JsRequestSection", "");
      this.$store.dispatch("set_current_section", id);
      this.$bus.$emit("send_interactive_msg", "JsRequestSection", id);

      this.extra_app_sibebar_class = "";
    },
    mute_ambience(e) {
      e.preventDefault();

      //console.log(this.$store.state.ambience_current_vol,this.$store.state.ambience_volume );
      var new_vol =
        this.ambience_current_vol == 0 ? this.$store.state.ambience_volume : 0;
      this.$bus.$emit("on-request-ambience-fade", new_vol);

      var event_value = new_vol == 0 ? "mute" : "unmute";
      this.$ga.event(
        this.eventTag + "-sound_events",
        event_value,
        event_value,
        1
      );
    },
    on_section_anim_ended() {
      //this.$store.dispatch("set_current_section", "");
      //this.allow_setting_active_links = false;
    },
    toggle_responsive_menu(e) {
      e.preventDefault();

      if (this.extra_app_sibebar_class == "") {
        this.extra_app_sibebar_class = "active";
      } else {
        this.extra_app_sibebar_class = "";
      }
    },
    cancel_guided_tour(e) {
      e.preventDefault();
      this.$bus.$emit("on-cancel-guided-tour");
      this.extra_app_sibebar_class = "";
      try {
        this.$ga.event(this.eventTag + "menubar", "click", "exit_tour", 1);
      } catch (err) {}
    },
    on_responsive_link_click(e, link_index) {
      try {
        this.$ga.event(
          this.eventTag + "footerlink",
          "click",
          this.footer_additional_links[i].title,
          1
        );
      } catch (err) {}
    }
  },
  mounted() {
    this.$bus.$on("on-section-anim-ended", this.on_section_anim_ended);
  }
};
</script>
<style scoped>
.app_sidebar {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 99vw;
  margin: 10px auto;
  border-radius: 6px;
  display: none !important;
}

.app-sidebar-instructions {
  background: rgba(20, 20, 20, 0.8);
  color: #fff;
  text-transform: uppercase;
}
.app-sidebar-wrap {
  padding: 2px 0;
  background: rgba(20, 20, 20, 0.75);
  position: relative;
}
.app-sidebar-content ul {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
li.section-item,
li.guided-item {
  flex: 1 1 12%;
  background: #121212;
  color: #fff;
  text-transform: uppercase;
  font-size: 11px;
  text-align: center;
  border-bottom: 1px solid #141414;
  display: inline-block;
  user-select: none;
  border-radius: 4px;
  line-height: 1.33;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 1px;
}
li.section-item.linked {
  cursor: pointer;
}

li.section-item-home {
  min-width: 70px;
  xflex: 0 1 15%;
  padding: 2px 0;
}
li.section-item-audio {
  xflex: 0 1 15%;
  padding: 2px 0;
}
li.section-item-home {
  display: flex;
  align-content: center;
  flex-flow: column;
  justify-content: center;
}
li.section-item-home img {
  width: 25px;
  min-width: 25px;
  min-height: 25px;
  max-height: 25px;
  margin: 0 auto;
  position: relative;
}
li.section-item.linked:hover {
  background: #161616;
}
li.section-item.active,
li.section-item.linked.active:hover,
li.guided-item.active,
li.guided-item.linked.active:hover {
  background-color: #000;
  color: #1260fe;
}
li.section-item-audio .mute-ambience-link {
  display: block !important;
  margin: 0 auto;
}
.mute-ambience-link {
  font-size: 12px;

  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  overflow: hidden;
  padding: 5px;
  display: none;
}
.mute-ambience-link span {
  background: url(../assets/unmute.png) 0 0 no-repeat;
  background-size: contain;
  background-position: center center;
  display: inline-block;
  width: 100%;
  height: 100%;
  max-width: 70px;
}
.mute-ambience-link.muted span {
  background-image: url(../assets/mute.png);
}
.section-item .mute-ambience-link {
  position: relative !important;
  margin: 0 0 0 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s !important;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media only screen and (min-width: 960px) {
  li.section-item {
    min-width: 177px;
    font-size: 11.5px;
    flex: 0;
  }
  li.section-item br {
    xdisplay: inline;
  }
  li.section-item-home {
    min-width: 50px;
    flex: 0 !important;
    padding: 2px !important;
  }

  li.section-item-audio {
    min-width: 70px;
    display: none;

    flex: 0 !important;
  }
  .mute-ambience-link {
    display: block;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>

<style>
.app_sidebar li.linked a {
  width: 100%;
}
.app_state_2 .app_sidebar {
  display: block;
}
.app_sidebar li.responsive-section-item {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AppSidebar.vue